import knownDomainsJson from './known-personal-email-domains.json';

// Snapshot of config/known_personal_email_domains.json at e827ab5e8196.
// Sync manually when the shared list's domain classifications change.

const knownPersonalEmailDomains = new Set(knownDomainsJson.domains);

/** Returns whether an email uses one of Figma's known personal email domains. */
export function hasKnownPersonalEmailDomain(email: string): boolean {
  const domain = email.toLowerCase().split('@')[1];
  return Boolean(domain && knownPersonalEmailDomains.has(domain));
}
